/** @format */

import React from 'react';

export const BrokerNameCellContent = ({
  firstName,
  lastName,
  isAbroadBroker = false
}) => {
  const AbroadBrokerIndicator = () => {
    if (isAbroadBroker) {
      return <span className='admin-abroad-broker-indicator'>(Abroad)</span>;
    }

    return <></>;
  };

  return (
    <>
      <span>{firstName}</span> <span>{lastName}</span>
      <br />
      <AbroadBrokerIndicator />
    </>
  );
};
